import { ToolbarSelectOptions as e } from "./toolbar-select.mjs";
import { ToolbarSheetRow as t } from "./toolbar-sheet-row.mjs";
import { Select as n } from "@systemeio/components";
import { jsx as r, jsxs as i } from "react/jsx-runtime";
//#region src/components/content-controls/toolbar-sheet-select.tsx
function a({ disabled: a, icon: o, label: s, onChange: c, options: l, value: u }) {
	return /* @__PURE__ */ i(n.Root, {
		disabled: a,
		drawerTitle: s,
		items: l,
		onValueChange: (e) => c(e),
		value: u ?? null,
		children: [/* @__PURE__ */ r(t, {
			closeOnClick: !1,
			disabled: a,
			icon: o,
			label: s,
			render: /* @__PURE__ */ r(n.Trigger, {
				unstyled: !0,
				onKeyDown: (e) => {
					(e.key === "ArrowDown" || e.key === "ArrowUp") && e.preventBaseUIHandler();
				}
			})
		}), /* @__PURE__ */ r(e, { options: l })]
	});
}
//#endregion
export { a as ToolbarSheetSelect };
